import { HrmManagement } from './HrmManagement';
import { HrmIntegratedManagement } from './HrmIntegratedManagement';
import { HrmSignupCard } from './HrmSignupCard';

export default function HrmDetails() {
    return (
        <div className="mt-[86px] mainContainer">
            <div className="flex flex-col gap-10">
                <HrmManagement
                    icon="recruitment"
                    title="التوظيف ومسار التعيين (Recruitment & Hiring Pipeline)"
                    description="نظّم عملية التوظيف بالكامل بداية من نشر الوظائف واستقبال المتقدمين، مرورًا بفرز الطلبات وجدولة المقابلات، وحتى متابعة مراحل التوظيف، لتضمن اختيار أفضل الكفاءات بسرعة واحترافية."
                />
                <HrmIntegratedManagement
                    icon="attendance"
                    title="إدارة الحضور والانصراف (Attendance & Time Tracking)"
                    description="تابع أوقات حضور وانصراف الموظفين بدقة وسهولة، مع تسجيل تلقائي للدوام، احتساب ساعات العمل والتأخير، وإدارة الورديات بشكل منظم، مما يساعد على رفع الانضباط وتحسين كفاءة العمل."
                />

                <HrmManagement
                    icon="performance"
                    title="تقييم أداء الموظفين (Performance Evaluation)"
                    description="قيّم أداء فريقك بناءً على معايير واضحة ومؤشرات أداء دقيقة، مع تقارير تساعدك على اكتشاف نقاط القوة وفرص التطوير، مما يساهم في رفع الإنتاجية وتحسين الأداء العام."
                />
                <HrmIntegratedManagement
                    title="إدارة العقود والهيكل التنظيمي ( Contracts & Employee Management )"
                    description="نظّم العقود، الأقسام، والأدوار الوظيفية في نظام واحد متكامل، مع سهولة الوصول إلى بيانات الموظفين وإدارتها بشكل احترافي."
                />
                <HrmManagement
                    icon="interface"
                    title="إدارة الورديات وتنظيم العمل "
                    description="خطّط للورديات وجدول العمل بمرونة، لضمان توزيع المهام بشكل متوازن وتحقيق سير عمل أكثر كفاءة واستقرارًا."
                />
            </div>
            <HrmSignupCard />
        </div>
    );
}
